import { BorrowerCity } from './components/BorrowerCity';
import { BorrowerState } from './components/BorrowerState';
import { BorrowerStreet1 } from './components/BorrowerStreet1';
import { BorrowerStreet2 } from './components/BorrowerStreet2';
import { BorrowerZipCode } from './components/BorrowerZipCode';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import {
    useBorrowerEntityStreet1,
    useBorrowerEntityStreet2,
    useBorrowerEntityCity,
    useBorrowerEntityState,
    useBorrowerEntityZipCode,
} from '../../../../../../queries/BorrowerFields/EntityFields';
import { ShowIf } from '../../../../../components/ShowIf';

interface BusinessMailingAddressProps {
    isReview?: boolean;
}

export const BusinessMailingAddress: React.FC<BusinessMailingAddressProps> = ({ isReview = false }) => {
    const [borrowerMailingAddyStreet1] = useBorrowerEntityStreet1();
    const [borrowerMailingAddyStreet2] = useBorrowerEntityStreet2();
    const [borrowerMailingAddyCity] = useBorrowerEntityCity();
    const [borrowerMailingAddyState] = useBorrowerEntityState();
    const [borrowerMailingAddyZip] = useBorrowerEntityZipCode();

    const fullAddress = () => {
        return (
            <>
                <div style={{ lineHeight: '1.5' }}>
                    {borrowerMailingAddyStreet1}
                    <ShowIf showIf={borrowerMailingAddyStreet2 != null}>
                        <br />
                        {borrowerMailingAddyStreet2}
                    </ShowIf>
                    <br />
                    {borrowerMailingAddyCity}, {borrowerMailingAddyState} {borrowerMailingAddyZip}
                </div>
            </>
        );
    };
    return (
        <>
            {isReview ? (
                <>
                    <ApplicationQuestionReviewItem
                        label='Business Mailing Address'
                        value={fullAddress()}
                    />
                </>
            ) : (
                <>
                    <div
                        className='pageSubHeader'
                        style={{ marginTop: 30 }}
                    >
                        Business Mailing Address
                    </div>
                    <BorrowerStreet1 isReview={isReview} />
                    <BorrowerStreet2 isReview={isReview} />
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                        <div style={{ flex: '1 1 100%' }}>
                            <BorrowerCity isReview={isReview} />
                        </div>
                        <div style={{ flex: '1 1 140px', minWidth: '140px' }}>
                            <BorrowerZipCode isReview={isReview} />
                        </div>
                        <div style={{ flex: '1 1 272px', minWidth: '272px' }}>
                            <BorrowerState isReview={isReview} />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
